<template>
    <div class="spinner-border" role="status">
        <svg class="d-block is--stop-color" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient :id="randomId" x1="2" y1="11" x2="20" y2="11" gradientUnits="userSpaceOnUse">
                    <stop :class="stopColor" />
                    <stop :class="stopColor" offset="1" stop-opacity="0" />
                </linearGradient>
            </defs>
            <path d="M11 2a9 9 0 1 0 9 9" :stroke="`url(#${randomId})`" stroke-width="3" stroke-linecap="round" />
        </svg>
        <span class="visually-hidden">{{ $t('ui.misc.loading') }}</span>
    </div>
</template>

<script>
    export default {
        name: 'Spinner',
        props: {
            color: {
                type: String,
                default: 'primary',
                validator: function (value) {
                    return ['primary', 'white', 'dark'].includes(value)
                }
            }
        },
        computed: {
            randomId() {
                return 'spinnerGradient-' + Math.floor(Math.random() * 100000);
            },
            stopColor() {
                return {
                    'stop-dark': this.color === 'dark',
                    'stop-primary': this.color === 'primary',
                    'stop-white': this.color === 'white',
                }
            }
        }
    }
</script>
